module.exports = __webpack_public_path__ + "img/DasDuell.dc640dd4.jpg";